export default __webpack_public_path__ + "static/media/weight-loss_clinician-call.adc05bef.jpg";